"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BuildTestIds = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Sync = _interopRequireDefault(require("@mui/icons-material/Sync"));
var _string = require("./../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  BuildTestIds = seedValue => {
    const bIsValidString = (0, _string.isStringOfLength)(seedValue);
    return {
      component: bIsValidString ? seedValue : undefined,
      content: bIsValidString ? `${seedValue}__content` : undefined,
      icon: bIsValidString ? `${seedValue}__icon` : undefined,
      heading: bIsValidString ? `${seedValue}__heading` : undefined
    };
  };

/**
 * Loading More Icon/Display
 *
 * @visibleName Loading
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.BuildTestIds = BuildTestIds;
const Loading = props => {
  const {
      children = "Loading...",
      customTheme = {},
      hidden = false,
      hideIcon = false,
      styles = {},
      tag = "h1",
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    componentStyles = {
      alignItems: "center",
      backgroundColor: "transparent",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: "2rem 0 !important",
      maxWidth: "100% !important",
      padding: " 2rem 0 !important",
      width: "100% !important",
      "@keyframes loadingRotate": {
        "from": {
          transform: "rotate(0deg)"
        },
        "to": {
          transform: "rotate(-360deg)"
        }
      },
      ".loading__content": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        margin: "0 auto",
        maxWidth: `${theme.breakpoints.values.lg}${theme.breakpoints.unit}`,
        textAlign: "center"
      },
      ".loading__heading": {
        margin: "0",
        padding: "0"
      },
      ".loading__icon": {
        animation: "2s linear infinite loadingRotate",
        height: "5rem",
        marginRight: "2rem",
        width: "5rem"
      }
    },
    testIds = BuildTestIds(testId);
  return /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: "loading",
    "data-testid": testIds.component,
    sx: merge(componentStyles, styles)
  }, !hidden && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "loading__content",
    "data-testid": testIds.content
  }, !hideIcon && /*#__PURE__*/_react.default.createElement(_Sync.default, {
    className: "loading__icon",
    alt: "Loading Icon",
    color: "#000000",
    "data-testid": testIds.icon
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "loading__heading heading--isInteriorPageHeading",
    component: tag,
    "data-testid": testIds.heading
  }, children)));
};
Loading.propTypes = {
  /** Optional children/content to display (Default Value: "Loading...") */
  "children": _propTypes.default.any,
  /** Theme injection object (Default Value: {}) */
  "customTheme": _propTypes.default.object,
  /** Boolean to hide the loading component (Default Value: false) */
  "hidden": _propTypes.default.bool,
  /** Boolean to hide the loading icon (Default Value: false) */
  "hideIcon": _propTypes.default.bool,
  /** Custom style object (Default Value: {}) */
  "styles": _propTypes.default.object,
  /** Tag for header element (Default Value: "h1") */
  "tag": _propTypes.default.string,
  /** @ignore */
  "testId": _propTypes.default.string
};
var _default = exports.default = Loading;